import React from 'react';
import { Link } from 'react-router-dom';
import { Modal } from 'semantic-ui-react';

class ModalLink extends React.Component {
  handleOnClick = (e) => {
    e.preventDefault();
    this.props.handleOpen();
  };

  render() {
    const { linkProps, modalProps } = this.props;
    return (
      <Modal
        trigger={<Link {...linkProps} onClick={this.handleOnClick} />}
        {...modalProps}
      />
    );
  }
}

export default ModalLink;



// WEBPACK FOOTER //
// ./app/components/Link/ModalLink/index.js